var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668ZM8.6951 4.66683C8.6951 4.2833 8.38418 3.97239 8.00065 3.97239C7.61712 3.97239 7.30621 4.2833 7.30621 4.66683V8.00016C7.30621 8.18434 7.37937 8.36098 7.50961 8.49121L9.86663 10.8482C10.1378 11.1194 10.5775 11.1194 10.8487 10.8482C11.1199 10.577 11.1199 10.1373 10.8487 9.86614L8.6951 7.71251V4.66683Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPending);
export default __webpack_public_path__ + "static/media/grey-pending.2ec69ee297ea1e0991afc12269583f42.svg";
export { ForwardRef as ReactComponent };